import {t} from "@lingui/core/macro";
import moment from "moment";
import * as React from "react";

import {View} from "@khanacademy/wonder-blocks-core";
import {sizing} from "@khanacademy/wonder-blocks-tokens";
import {Body, LabelSmall} from "@khanacademy/wonder-blocks-typography";

import type {ActivitySessionsV2Query_user_activityLogV2_activitySessions_sessions as ActivitySessionsReportRow} from "./__graphql-types__/ActivitySessionsV2Query.ts";
import isBasicActivitySession from "./is-basic-activity-session.ts";

interface Props {
    row: ActivitySessionsReportRow;
}

const formatDate = (date?: string | null) => {
    if (!date) {
        return "";
    }
    const momentDate = moment(date);
    return t`${momentDate.format("MMM DD, YYYY")} at ${momentDate.format("LT")}`;
};

const DateCell: React.FC<Props> = ({row}) => (
    <View style={styles.activityCell}>
        <Body style={styles.nowrap}>{formatDate(row.eventTimestamp)}</Body>
        {!isBasicActivitySession(row) && row.task?.isRestarted && (
            <LabelSmall style={styles.startOverLabel}>
                {t`Used "Start over"`}
            </LabelSmall>
        )}
    </View>
);

const styles = {
    activityCell: {
        paddingBlockStart: sizing.size_120,
        paddingBlockEnd: sizing.size_120,
        maxWidth: 280,
        height: 70,
        justifyContent: "center",
    },
    nowrap: {
        whiteSpace: "nowrap",
    },
    startOverLabel: {
        fontStyle: "italic",
        marginBlockStart: sizing.size_040,
    },
} as const;

export default DateCell;
